import { zodResolver } from '@hookform/resolvers/zod'
import { ArrowLeft, MailCheck } from 'lucide-react'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Link } from 'react-router'
import { z } from 'zod'
import { Button, Input } from '@/design-system'
import { AuthLayout } from './AuthLayout'
import { useAuth } from './useAuth'

const schema = z.object({ email: z.email('Saisissez un courriel valide.') })
type FormValues = z.infer<typeof schema>

export function ForgotPasswordPage() {
  const { requestPasswordReset } = useAuth()
  const [sent, setSent] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>({ resolver: zodResolver(schema) })
  const submit = handleSubmit(async ({ email }) => {
    try {
      await requestPasswordReset(email)
    } catch {
      // Le refus est volontairement masqué pour ne pas révéler le compte.
    }
    setSent(true)
  })

  return (
    <AuthLayout>
      <div className="auth-card__heading">
        <span className="auth-page__eyebrow">Récupération</span>
        <h2>Réinitialiser le mot de passe</h2>
        <p>Nous enverrons un lien temporaire si ce courriel est associé à un compte.</p>
      </div>
      {sent ? (
        <div className="auth-success" role="status">
          <MailCheck aria-hidden="true" />
          <strong>Vérifiez votre boîte de réception</strong>
          <p>Si un compte correspond, les instructions viennent d’être envoyées.</p>
        </div>
      ) : (
        <form
          className="auth-form"
          onSubmit={(event) => {
            void submit(event)
          }}
        >
          <Input
            label="Courriel professionnel"
            type="email"
            autoComplete="email"
            error={errors.email?.message}
            {...register('email')}
          />
          <Button type="submit" variant="primary" size="large" loading={isSubmitting}>
            Envoyer le lien sécurisé
          </Button>
        </form>
      )}
      <Link className="auth-back-link" to="/login">
        <ArrowLeft aria-hidden="true" /> Retour à la connexion
      </Link>
    </AuthLayout>
  )
}
